module.exports = __webpack_public_path__ + "assets/images/new-on.png";


//////////////////
// WEBPACK FOOTER
// ./client/app/assets/images/new-on.png
// module id = 1519
// module chunks = 1